import React from 'react';

/**
 * Wrapper component for protected routes
 * Note: AuthProvider is now at the App level, so we don't wrap again here
 */
const ProtectedRoute = ({ children }) => {
  return children;
};

export default ProtectedRoute;
